'use client'
import { TurnkeyWalletConnectorInfo } from '@dynamic-labs/embedded-wallet';
import { TurnkeySolanaWalletConnector } from './lib/TurnkeySolanaWalletConnector/TurnkeySolanaWalletConnector.js';

const TurnkeySolanaWalletConnectors = (props) => {
    var _a;
    if ((_a = props.apiProviders) === null || _a === void 0 ? void 0 : _a.turnkey) {
        return [
            class extends TurnkeySolanaWalletConnector {
                constructor(innerProps) {
                    super(TurnkeyWalletConnectorInfo.TurnkeyHD, Object.assign(Object.assign({}, props), innerProps));
                }
            },
        ];
    }
    return [];
};

export { TurnkeySolanaWalletConnectors };
